import { Button, DrawerProps, Form, FormProps, Typography } from 'antd';
import { antdDrawer, useModal, create } from '@ebay/nice-modal-react';

import UserAccountFields from '../forms/UserAccountFields';
import { useAuth } from '../../context/AuthContext';
import { defaultErrorMessage, requiredFieldsText } from '../../i18n';
import { errorMessage, successMessage } from '../../helpers/message';
import CustomDrawer from '../CustomDrawer';
import ProvidersField from '../forms/ProvidersField';

type Props = DrawerProps & Record<string, any>;

const ProfileFormDrawer = create<Props>(({ ...props }) => {
    const modal = useModal();
    const [form] = Form.useForm();
    const { user, updateUser } = useAuth();
    const { mutate: update, isLoading } = updateUser;
    const onFormValidSubmit: FormProps['onFinish'] = (values) => {
        update(
            { ...values.user },
            {
                onSuccess: () => {
                    modal.hide();
                    successMessage({
                        content: 'Votre profil a été modifié avec succès',
                    });
                },
                onError: (error) => {
                    errorMessage({
                        content: `${defaultErrorMessage} (${error?.response?.status ?? 0})`,
                    });
                },
            }
        );
    };

    return (
        <CustomDrawer width={500} title="Votre profil" {...props} {...antdDrawer(modal)}>
            <Form
                form={form}
                onFinish={onFormValidSubmit}
                layout="vertical"
                initialValues={{
                    user,
                }}
                scrollToFirstError
            >
                <UserAccountFields isMe />
                <ProvidersField readOnly />
                <Form.Item className="mb-32" shouldUpdate>
                    {() => (
                        <Button
                            type="primary"
                            htmlType="submit"
                            size="large"
                            loading={isLoading}
                            disabled={
                                !form.isFieldsTouched() ||
                                form.getFieldsError().filter(({ errors }) => errors.length).length > 0
                            }
                            block
                        >
                            Enregistrer les modifications
                        </Button>
                    )}
                </Form.Item>
                <Typography.Paragraph className="text-center mb-0">
                    <Typography.Text className="font-12">{requiredFieldsText}</Typography.Text>
                </Typography.Paragraph>
            </Form>
        </CustomDrawer>
    );
});

export default ProfileFormDrawer;
